export default __webpack_public_path__ + "static/media/product_banner_1.bb81a79d.jpg";